<div class="main-panel">
    <div class="content-wrapper">
        <div class="row">
            <div class="col-lg-12">
                <div>
                    <p class="text-primary sub">{{serverId ? 'Server Wise Login Trend Report' :'Subscription wise Login
                        Trend Report'}}</p>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-12 stretch-card">
                        <div class="card">
                            <div class="card-body">
                                <div class="mt-2 ms-3">
                                    <button class="graph me-2" [ngClass]="chartType=='line'?'active':''"
                                        (click)="toggleChartType('line')">Line</button>
                                    <button class="graph" [ngClass]="chartType=='column'?'active':''"
                                        (click)="toggleChartType('column')">Bar</button>
                                </div>
                                <div class="float-end">
                                    <ul class="days">
                                        <li *ngFor="let timePeriod of timePeriods; let i = index"
                                            (click)="currentTimePeriod(timePeriod.value)"
                                            [ngClass]="{'activate': activeLoginSection === timePeriod.value}">
                                            <span>{{ timePeriod.name | titlecase }}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div id="loginTrendChart" class="d-flex mt-5 justify-content-center align-items-center"
                                    style="height: 300px;">
                                    <highcharts-chart [Highcharts]="Highcharts" [options]="loginTrendOption"
                                        [(update)]="updateFromInput" style="display: none;"></highcharts-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-lg-12 stretch-card">
                        <div class="card">
                            <div class="card-body">

                                <div class="row" *ngIf="serverId">
                                    <h3 class="txt text-black"><b>Server Wise Details</b></h3>

                                    <div class="col-md-6">
                                        <div *ngFor="let item of serverDetailsLeft" class="info-row">
                                            <span class="info-heading">{{ item.label }}:</span>
                                            <span class="info-value">{{ details?.[item.key] }}</span>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div *ngFor="let item of serverDetailsRight" class="info-row">
                                            <span class="info-heading">{{ item.label }}:</span>
                                            <span class="info-value">{{ details?.[item.key] }}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>